import { Injectable } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";

@Injectable()
export class VolverService {
  // true si fue click en el botón volver (se modifica en el componente "volver.component.ts")
  static click_en_volver: boolean = false;
  // true su volvieron a la misma página usando el botón volver
  static volvieron_a_la_pagina_con_boton_volver: boolean = false;

  constructor(
    private router: Router
  ) {
    // al navegar sobre pantallas
    this.router.events
      .filter(event => event instanceof NavigationEnd)
      .subscribe(() => {
        // hicieron click en el botón volver (fue a otra página y volvió con volver)
        if (VolverService.click_en_volver)
          VolverService.volvieron_a_la_pagina_con_boton_volver = VolverService.click_en_volver;

        setTimeout(() => {
          VolverService.click_en_volver = false;
          VolverService.volvieron_a_la_pagina_con_boton_volver = false;
        }, 250);
      });
  }

  /**
   * retorna true si es un regreso a la misma página
   * desde un botón de volver
   */
  usaronBotonVolver(): boolean {
    return VolverService.volvieron_a_la_pagina_con_boton_volver;
  }
}